import React, { useRef, useState, useEffect } from 'react';
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import * as NavigationActions from '../navigation/actions';

import classnames from 'classnames';
import thdJbrLogoVert from './thdjbr-logo-vert.svg';
import thdJbrLogoHoriz from './thdjbr-logo-horiz.svg';
import thdjbrLogin from '../icons/StrokeLogin';
import thdjbrSignup from '../icons/StrokeSignup';

//import '../css/NavBar.css';

// Note that I have replaced "<a href=" to "<Link" in this source and selected-actions.js.  If some problem occures, I should restore the original statement.
const NavLink = ({
  dispatch,
  pathname,
  to,
  icon,
  disabled,
  children
}) => {
  const Svg = icon;
  const active = pathname === to;
  const anchorClass = classnames({
        'bg-white-10 navbar-item-active': active,
        'o-50 no-pointer-events': disabled
      }, ['navbar-item dib db-l pt2 pb3 pv1-l white no-underline f5 hover-bg-white-10 tc bb bw2 bw0-l b--navy']);
  const svgClass = classnames({
    'o-100': active,
    'o-50': !active
      }, ['fill-current-color mv2']);

  return (
    <Link to={to} className={anchorClass} role='menuitem' title={children}>
      <div className='db ph2 pv1'>
        <div className='db'>
          <Svg width='46' role='presentation' className={svgClass} />
        </div>
        <div className={`${active ? 'o-100' : 'o-50'} db f6 tc times-new-roman ttu fw1 `} style={{ whiteSpace: 'pre-wrap' }}>
          {children}
        </div>
      </div>
    </Link>
  );
}

const NavBar = ({
  dispatch,
  pathname
}) => {
  const elm = useRef();

  const [ dimention, setDimention ] = useState({
    fullWidth: window.innerWidth,
    fullHeight: window.innerHeight });
  const NAVBAR = 959;
  const navBarActive = dimention.fullWidth > NAVBAR;
  var navBarWidth = null;
  var navBarHeight = null;

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, []);

  const handleResize = () => {
    setDimention({
      fullWidth: window.innerWidth,
      fullHeight: window.innerHeight
    });
  }

  useEffect(() => {
    navBarHeight = elm.current.getBoundingClientRect().height;
    navBarWidth = elm.current.getBoundingClientRect().width;
    dispatch(notifyNavBarHorizDimention(navBarWidth, navBarHeight, navBarActive));
  }, [dimention.fullWidth, dimention.fullHeight])

  if (navBarActive)
    return (
      <div className='fixed z-4 flex flex-column justify-between' style={{ overflowY: 'auto', width: 'inherit' }}>
        <div ref={elm} className='flex flex-column'>
          <div className='pt3 pb1 pb2-l'>
            <Link to='/welcome' role='menuitem' title='Welcome page'>
              <img className='navbar-logo-vert center db-l dn pt3 pb1' style={{ height: 94 }} src={thdJbrLogoVert} alt='' />
            </Link>
          </div>
          <div className='db overflow-x-hidden-l nowrap tc' role='menubar'>
            <PrivateNavLink to='/login' icon={thdjbrLogin} pathname={pathname}>Login</PrivateNavLink>
            <PrivateNavLink to='/signup' icon={thdjbrSignup} pathname={pathname}>Signup</PrivateNavLink>
          </div>
        </div>
      </div>
    )
  else
    return (
      <div ref={elm} className='w-100 fixed z-4 flex flex-column justify-between' style={{ overflowY: 'auto' }}>
        <div className='flex flex-column'>
          <div className='flex justify-center pt3 pb1 pb2-l'>
            <Link to='/welcome' role='menuitem' title='Welcome page'>
              <img className='navbar-logo-horiz z-4 center db dn-l' style={{ height: 64 }} src={thdJbrLogoHoriz} alt='' />
            </Link>
          </div>
          <div className='flex justify-end db overflow-x-hidden-l nowrap tc' role='menubar'>
            <PrivateNavLink to='/login' icon={thdjbrLogin} pathname={pathname}>Login</PrivateNavLink>
            <PrivateNavLink to='/signup' icon={thdjbrSignup} pathname={pathname}>Signup</PrivateNavLink>
          </div>
        </div>
      </div>
    )
}

const notifyNavBarHorizDimention = (navBarWidth, navBarHeight, navBarActive) => {
  return {
    type: NavigationActions.HORIZHEIGHT_DETERMINDED,
    navBarWidth: navBarWidth,
    navBarHeight: navBarHeight,
    navBarActive: navBarActive
  }
}

const mapStateToProps = state => ({
  pathname: state.router.location.pathname
})

const PrivateNavLink = connect(mapStateToProps)(NavLink);
export default connect(mapStateToProps)(NavBar);
